import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import {
  autopairingFeatureKey,
  autopairingReducer,
  initialState as autopairInitialState
} from '../../store/autopairing/autopairing.reducer';
import { AutopairingEffects } from '../../store/autopairing/autopairing.effects';
import { EffectsModule } from '@ngrx/effects';
import {
  dataDictionaryFeatureKey,
  dataDictionaryReducer,
  initialState as dataDictionaryInitialState
} from '../../store/data-dictionary/data-dictionary.reducer';
import { DataDictionaryEffects } from '../../store/data-dictionary/data-dictionary.effects';
import {
  mobilityManagerFeatureKey,
  mobilityManagerInitialState,
  mobilityManagerReducer
} from '../../store/mobility-manager/mobility-manager.reducer';
import { MobilityManagerEffects } from '../../store/mobility-manager/mobility-manager.effects';

// This module is responsible for setting up the NGRX store for standalone components.
// When/If the app is converted to a full standalone app, this module can be removed, and
// these imports can be added to the app bootstrap directly.

@NgModule({
  imports: [
    StoreModule.forFeature(autopairingFeatureKey, autopairingReducer, {
      initialState: autopairInitialState
    }),
    EffectsModule.forFeature([AutopairingEffects]),

    StoreModule.forFeature(dataDictionaryFeatureKey, dataDictionaryReducer, {
      initialState: dataDictionaryInitialState
    }),
    EffectsModule.forFeature([DataDictionaryEffects]),
    StoreModule.forFeature(mobilityManagerFeatureKey, mobilityManagerReducer, {
      initialState: mobilityManagerInitialState
    }),
    EffectsModule.forFeature([MobilityManagerEffects])
  ]
})
export class CrmStoreModule {}
